import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents.ts';

import { MediaScreen } from '../MediaScreen';

export const Photo: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Photo',
      });
    }
  }, []);

  return (
    <MediaScreen
      title="I can send you pictures"
      videoSrc={`${S3_BUCKET_URL}/layout-own-ai-maxim/photo/photo.webm`}
      videoAlt="Photo screen"
      buttonText="I'm intrigued"
      screenName="Photo Screen"
    />
  );
};
